<div class="header-section">
  <h3 class="clsCard_Title">
    {{ 'component.open-production-findings.title' | translate }}
  </h3>
  <div class="filter-icon">
    <div (click)="toggleFiltersEnabled()">
      <img
        alt=""
        src="assets/images/icons/icon-filter.svg"
        width="30"
        height="30"
      />
      <span>{{
        'component.open-production-findings.filter-icon-label' | translate
      }}</span>
    </div>
  </div>
</div>
<div class="card clsCardContainer production-statistics">
  <div class="production-statistics-item">
    <p>{{ liveSecurityFindingsResponse?.liveSecurityFindingsCount }}</p>
    <p>
      {{
        'component.open-production-findings.production-statistics.total-issues'
          | translate
      }}
    </p>
  </div>
  <div class="production-statistics-item">
    <p>
      {{ liveSecurityFindingsResponse?.affectedAppsCount
      }}<span>/{{ liveSecurityFindingsResponse?.totalAppsCount }}</span>
    </p>
    <p>
      {{
        'component.open-production-findings.production-statistics.affected-apps'
          | translate
      }}
    </p>
  </div>
  <div class="production-statistics-item">
    <p>{{ liveSecurityFindingsResponse?.criticalSeverityFindingsCount }}</p>
    <p>
      {{
        'component.open-production-findings.production-statistics.critical-issues'
          | translate
      }}
    </p>
  </div>
  <div class="production-statistics-item">
    <p>{{ liveSecurityFindingsResponse?.highSeverityFindingsCount }}</p>
    <p>
      {{
        'component.open-production-findings.production-statistics.high-issues'
          | translate
      }}
    </p>
  </div>
</div>

<div *ngIf="filtersEnabled" class="app-table-filters">
  <form [formGroup]="securityFindingsFilterForm"></form>
  <div class="search-bar-filter form-inline">
    <input
      [formControl]="securityFindingsFilterForm.controls.text"
      type="text"
      class="form-control"
      [placeholder]="
        'component.open-production-findings.app-table-filters.search-input.placeholder'
          | translate
      "
    />

    <button type="button">
      <img
        src="assets/images/icons/magnifying_glass_detail.png"
        width="16"
        height="16"
        alt=""
      />
      {{
        'component.open-production-findings.app-table-filters.search-input.button'
          | translate
      }}
    </button>
  </div>
  <app-select
    [appSelectOptions]="platformAppSelectOptions"
    [label]="
      'component.open-production-findings.app-table-filters.platform-select.label'
        | translate
    "
    [horizontalLabel]="true"
    [appSelectFormControl]="securityFindingsFilterForm.controls.platform"
  ></app-select>
  <app-select
    [appSelectOptions]="severityAppSelectOptions"
    [label]="
      'component.open-production-findings.app-table-filters.severity-select.label'
        | translate
    "
    [horizontalLabel]="true"
    [appSelectFormControl]="securityFindingsFilterForm.controls.severity"
  ></app-select>
  <div (click)="clearFilters()" class="clear-filters">
    <img
      width="20"
      height="20"
      src="assets/images/icons/icons-close-on.svg"
      alt=""
    />
    <p>
      {{
        'component.open-production-findings.app-table-filters.clear-filters'
          | translate
      }}
    </p>
  </div>
</div>
<app-table
  [rowTemplate]="customRowTemplate"
  [appTableRows]="appTableRows"
  [data]="displayingLiveSecurityFindings"
>
  <ng-template
    #customRowTemplate
    let-columnName="columnName"
    let-data="$value"
    let-row="row"
  >
    <div class="severity-cell" *ngIf="columnName === 'severity'">
      <div [ngClass]="getSeverityDotClasses(data)" class="severity-dot"></div>
      <span>{{ data | capitalLetter }}</span>
    </div>
    <div *ngIf="columnName === 'appPlatform'">
      <img
        alt=""
        width="30"
        height="30"
        [src]="defineAppPlatformImageSource(data)"
      />
    </div>
    <div *ngIf="columnName === 'openingDate'">
      <span>{{ data | date: 'dd-MMM-yyyy' }}</span>
    </div>
    <div class="actions-cell" *ngIf="columnName === 'actions'">
      <a [href]="row.findingUrl" target="_blank">
        <img
          width="20"
          height="20"
          [matTooltip]="
            'component.open-production-findings.app-table.go-to-finding-tooltip'
              | translate
          "
          matTooltipPosition="below"
          src="assets/images/icons/link-icon.png"
          alt=""
        />
      </a>
      <img
        class="pointer"
        (click)="openSecurityFindingsDetailDialog(row)"
        width="20"
        height="20"
        [matTooltip]="
          'component.open-production-findings.app-table.close-finding-tooltip'
            | translate
        "
        matTooltipPosition="below"
        [src]="defineCloseFindingTooltipImage(row.id)"
        alt=""
      />
    </div>
    <div *ngIf="isDefaultColumn(columnName)">
      <span>{{ data }}</span>
    </div>
  </ng-template>
</app-table>
